import React from 'react';
import {InstantSearch} from 'react-instantsearch/dom';
import Search from './Search';
import SignIn from './SignIn';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  return (
    <nav className="navbar navbar-dark sticky-top page-header flex-md-nowrap p-0">
        <a className="navbar-brand col-3 col-2 mr-0" href="#">MISE API</a>
        {/* <InstantSearch
          appId="latency"
          apiKey="3d9875e51fbd20c7754e65422f7ce5e1"
          indexName="bestbuy"
        >
          <Search />
        </InstantSearch> */}
        <LanguageSelector />
        {/* <SignIn /> */}
    </nav>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js